(function() {
    const cloudWords = [
        { text: '💍 Mariage', weight: 4 },
        { text: '🎂 Anniversaire', weight: 4 },
        { text: '👶 Naissance', weight: 4 },
        { text: '💝 Saint Valentin', weight: 4 },
        { text: '🎄 Noël', weight: 4 },
        { text: '🌹 Fête des Mères', weight: 4 },
        { text: '👨 Fête des Pères', weight: 4 },
        { text: '👵👴 Fête des Grands-Parents', weight: 4 },
        { text: '🎉 Départ Retraite', weight: 4 },
        { text: '💎 Demande en Mariage', weight: 4 },
        { text: '🤰 Grossesse', weight: 4 },
        { text: '🎈 Heureux Événement', weight: 4 },
        { text: '💙💗 Gender Reveal ', weight: 4 },
        { text: '🎊 Surprise', weight: 4 },
        { text: '👰 EVJF', weight: 5 },
        { text: '🤵 EVG', weight: 4 },
        { text: '👣 Premiers Pas', weight: 4 },
        { text: '✈️ Voyages', weight: 4 },
        { text: '🐾 Adoption Animal', weight: 4 },
        { text: '❤️ Première Rencontre', weight: 4 }
    ];

    function shuffleArray(array) {
        const newArray = [...array];
        for (let i = newArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
        }
        return newArray;
    }

    const isDesktop = window.matchMedia('(min-width: 769px)').matches;

    function initWordCloud() {
        const container = document.getElementById('shopifyWordCloud');
        if (!container) return;
        
        const shuffledWords = shuffleArray(cloudWords);
        
        // ✅ OPTIMISÉ: Double au lieu de triple (40 éléments au lieu de 60)
        const doubledWords = [...shuffledWords, ...shuffledWords];
        
        // ✅ OPTIMISÉ: Utilise DocumentFragment pour insertion unique (performance)
        const fragment = document.createDocumentFragment();
        
        doubledWords.forEach((word, index) => {
            const span = document.createElement('span');
            span.className = `cloud-word size-${word.weight} color-${(index % 7) + 1}`;
            span.textContent = word.text;
            
            // ✅ OPTIMISÉ: Pause au clic UNIQUEMENT sur desktop
            if (isDesktop) {
                span.addEventListener('click', function() {
                    if (container.style.animationPlayState === 'paused') {
                        container.style.animationPlayState = 'running';
                    } else {
                        container.style.animationPlayState = 'paused';
                    }
                });
            }
            
            fragment.appendChild(span);
        });
        
        // ✅ OPTIMISÉ: Une seule insertion DOM
        container.appendChild(fragment);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWordCloud);
    } else {
        initWordCloud();
    }
})();